var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_5001_3502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 40,
    fill: "url(#paint0_linear_5001_3502)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 44,
    fill: "url(#paint1_linear_5001_3502)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5001_3502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 32.5C57.1004 32.5 54.75 34.8505 54.75 37.75H65.25C65.25 34.8505 62.8996 32.5 60 32.5ZM68.75 37.75C68.75 32.9175 64.8325 29 60 29C55.1675 29 51.25 32.9175 51.25 37.75H39V41.25H42.5V71H77.5V41.25H81V37.75H68.75ZM51.8328 48.25V60.5H55.3328V48.25H51.8328ZM64.6655 48.25V60.5H68.1655V48.25H64.6655Z",
    fill: "url(#paint2_linear_5001_3502)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5001_3502",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_5001_3502"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5001_3502",
    x1: 20,
    y1: 20,
    x2: 100,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5001_3502",
    x1: 16,
    y1: 6,
    x2: 104,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5001_3502",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5001_3502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(39 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePop);
export default __webpack_public_path__ + "static/media/delete_pop.769556f36cb1f164749e67e4b0f0a096.svg";
export { ForwardRef as ReactComponent };